/**
 * The files a paste or a drop carries. A screenshot often arrives only as a file item, and some browsers fill only
 * `files`. Each `getAsFile()` call makes a new File, so the two lists can't be merged without duplicates.
 * A dropped folder is left out. `files` lists it too, so a folder among the items also blocks that fallback.
 */
export function filesFromDataTransfer(
  transfer: Pick<DataTransfer, "files" | "items"> | null | undefined,
): File[] {
  if (!transfer) return [];
  let hasFolder = false;
  const fromItems = Array.from(transfer.items ?? []).flatMap((item) => {
    if (item.kind !== "file") return [];
    if (item.webkitGetAsEntry?.()?.isDirectory) {
      hasFolder = true;
      return [];
    }
    const file = item.getAsFile();
    return file ? [file] : [];
  });
  return fromItems.length > 0 || hasFolder
    ? fromItems
    : Array.from(transfer.files ?? []);
}
